import * as _accessors from './accessors';
import * as _actions from './actions';
import _reducer from './reducer';
import _RAv2HomeworkResultSummary from './model';

export const accessors = _accessors;
export const actions = _actions;
export const reducer = _reducer;
export const RAv2HomeworkResultSummary = _RAv2HomeworkResultSummary;



// WEBPACK FOOTER //
// ./data/RAv2HomeworkResultSummary/index.js